<template>
  <master-main
    :addProperties="{
      isWizard: false,
    }"
    :exportProperties="{
      pdf: {
        filename: `${$t('production.production_units')}.pdf`,
        route: `${getModuleRoute}/pdf`,
        paramMethod: 'POST',
        plusData: { ...exportData },
      },
      xls: {
        filename: `${$t('production.production_units')}.xlsx`,
        route: `${getModuleRoute}/excel`,
        paramMethod: 'POST',
        plusData: { ...exportData },
      },
    }"
    :dataBadges="[
      {
        columnLabel: $t('common_words.associated_companies2'),
        data: 'businesses',
        property: 'name',
        minWidth: 160,
      },
    ]"
    :route="getModuleRoute"
    :showProperties="showProperties"
    :tableProperties="tableProperties"
    @closeModal="handleCloseModal"
    @openModal="handleOpenModal"
    @refresh="refresh"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
    ref="masterMain"
  >
    <template slot="dialogForm">
      <edit-or-create-production-unit
        v-if="renderComponent"
        :syncDialog="modals"
        @addEdit="addEdit"
        @closeModal="handleCloseModal"
        @showHideLoading="showHideLoading"
        @showNotification="notifyVue"
        ref="editCreate"
      />
    </template>
  </master-main>
</template>
<script>
import EditCreate from './EditCreate.vue';
import UnitsTable from './production-units-table';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinRerender from 'src/mixins/mixin-rerender';
import MixinWithDialog from 'src/mixins/master/mixin-with-dialog';

export default {
  components: { MasterMain, [EditCreate.name]: EditCreate },
  data() {
    return {
      tableProperties: {},
      showProperties: { size: '70%' },
    };
  },
  mixins: [
    MixinAlert,
    MixinForm,
    MixinLoading,
    MixinMain,
    MixinPermissions,
    MixinRerender,
    MixinWithDialog,
  ],
  computed: {
    getModuleRoute() {
      return 'cutting/productionunits';
    },
    exportData() {
      return {
        data: { ...this.tableProperties.data },
      };
    },
    buildTableProperties() {
      return {
        tableColumns: [...UnitsTable().tableColumns],
        model: 'productionunit',
        effectTags: 'dark',
        defaultSort: { prop: 'id', order: 'descending' },
      };
    },
  },
};
</script>
